(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/assets/react/navigation-handler.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/assets/react/navigation-handler.js');
"use strict";

const _ReactRouterDOM = ReactRouterDOM,
  useLocation = _ReactRouterDOM.useLocation;
const _React = React,
  useEffect = _React.useEffect;
setGlobal('svs.lyckoplatsen.react.NavigationHandler', () => {
  const _useLocation = useLocation(),
    pathname = _useLocation.pathname;
  useEffect(() => {
    const menuItems = document.querySelectorAll('.js-items-menu-item');
    menuItems.forEach(item => {
      item.classList.remove('items-menu-active');
    });
    const activeItem = Array.from(menuItems).find(item => {
      const cleanName = item.getAttribute('href').replace(svs.core.data.baseUrl, '');

      if (cleanName === '') {
        return pathname === '/';
      }
      if (pathname.startsWith("/forlang-mina-spel")) {
        return cleanName === '/spela';
      }
      return pathname === cleanName || pathname.startsWith("".concat(cleanName, "/"));
    });
    if (activeItem) {
      activeItem.classList.add('items-menu-active');
    }
  }, [pathname]);
  useEffect(() => {
    const handleClick = event => {
      const clickedItem = event.currentTarget;
      const label = clickedItem.textContent.trim();
      svs.components.analytics.trackEvent({
        category: 'lyckoplatsen_nav',
        action: 'click_secondaryMenu',
        opt_label: label
      });
    };
    const menuItems = document.querySelectorAll('.js-items-menu-item');
    menuItems.forEach(item => {
      item.addEventListener('click', handleClick);
    });
    return () => {
      menuItems.forEach(item => {
        item.removeEventListener('click', handleClick);
      });
    };
  }, []);
  return null;
});

 })(window);